export const reportPurchaseConstants={
    GET_REPORT_PURCHASE: "GET_REPORT_PURCHASE_LIST",
    GET_REPORT_PURCHASE_SUCCESS: "GET_REPORT_PURCHASE_LIST_SUCCESS",
    GET_REPORT_PURCHASE_FAILURE: "GET_REPORT_PURCHASE_LIST_FAILURE",
}